import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturesDark from './components/FeaturesDark';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import AppStore from './components/AppStore';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import Terms from './components/Terms';

function HomePage() {
  return (
    <>
      <Hero />
      <FeaturesDark />
      <Reviews />
      <FAQ />
      <AppStore />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#0B0F19] text-white selection:bg-[#E63946] selection:text-white flex flex-col overflow-x-hidden">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms&condition" element={<Terms />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}
